import { css } from "styled-system/css";
import type { RealStatus } from "@/lib/trial-days";

export type { RealStatus };

export const ACCOUNT_STATUS_CONFIG: Record<
  RealStatus,
  { label: string; bg: string; color: string; dot: string }
> = {
  paying: {
    label: "Pagando",
    bg: "#dcfce7",
    color: "#15803d",
    dot: "#16a34a",
  },
  on_trial: {
    label: "En prueba",
    bg: "#fef9c3",
    color: "#854d0e",
    dot: "#ca8a04",
  },
  trial_expired: {
    label: "Prueba vencida",
    bg: "#fee2e2",
    color: "#b91c1c",
    dot: "#dc2626",
  },
  inactive: {
    label: "Inactivo",
    bg: "#f1f5f9",
    color: "#64748b",
    dot: "#94a3b8",
  },
  free: {
    label: "Free activo",
    bg: "#f1f5f9",
    color: "#64748b",
    dot: "#94a3b8",
  },
};

export function AccountStatusBadge({ status }: { status: RealStatus }) {
  const { label, bg, color } = ACCOUNT_STATUS_CONFIG[status];
  return (
    <span
      className={css({
        display: "inline-block",
        px: "2",
        py: "0.5",
        rounded: "md",
        fontSize: "xs",
        fontWeight: "semibold",
        whiteSpace: "nowrap",
      })}
      style={{ background: bg, color }}
    >
      {label}
    </span>
  );
}
